import { useEffect, useRef, useState } from 'preact/hooks';

import { useAppState } from '@/shared/stores/app-store/app-store';

import { MessageAction, MessageType } from './types';

import { type UseWsReturnType } from '.';

enum STATUS {
  OFFLINE = 'offline',
  ONLINE = 'online',
}

const MINING_TIMER = 5000;

export function useMining(ws: UseWsReturnType, disabled?: boolean) {
  const { wsSentInitialMsg } = useAppState();
  const [subscribed, setSubscribed] = useState(false);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (!wsSentInitialMsg) return;
    const subscriptionId = ws.subscribe(MessageType.MINING);

    return () => ws.unsubscribe(MessageType.MINING, subscriptionId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wsSentInitialMsg]);

  useEffect(() => {
    if (disabled || subscribed) return;

    setSubscribed(true);

    const sendMiningMessage = (status: STATUS) =>
      ws.sendMessage(MessageType.MINING, MessageAction.EXECUTE, { status });

    intervalRef.current = setInterval(
      () => sendMiningMessage(STATUS.ONLINE),
      MINING_TIMER
    );

    return () => {
      sendMiningMessage(STATUS.OFFLINE);
      clearInterval(intervalRef.current!);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disabled]);
}
